// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FormatListNumberedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="FormatListNumberedIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="m2.342 4.68.915-.25v2.91H2.261V8.5H5.5V7.341H4.575V3H3.619L2 3.904z" />
      <path d="M8 4.018h9.982v1.498H8z" />
      <path d="M8 9.25h10v1.498H8z" />
      <path d="M17.982 14.493H8v1.498h9.982z" />
      <path d="m3.466 14.561-1.234 1.296V17H5.73v-1.245H3.962l.757-.775.06-.062a7 7 0 0 0 .536-.643 2.4 2.4 0 0 0 .324-.581 1.8 1.8 0 0 0 .11-.612 1.5 1.5 0 0 0-.232-.817 1.6 1.6 0 0 0-.646-.56A2.2 2.2 0 0 0 3.91 11.5c-.496 0-.9.122-1.234.367a1.8 1.8 0 0 0-.667 1l1.051.419a.93.93 0 0 1 .303-.48.76.76 0 0 1 .486-.173.7.7 0 0 1 .333.071.5.5 0 0 1 .233.204.6.6 0 0 1 .08.306.6.6 0 0 1-.08.296 1.6 1.6 0 0 1-.223.306c-.1.113-.222.235-.353.368z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FormatListNumberedIcon = /* @__PURE__ */ Object.assign(
  FormatListNumberedIconComponent,
  { displayName: 'FormatListNumberedIcon' },
);
